
import { useDashboard } from "@/hooks/useDashboard";
import DashboardHeader from "@/components/dashboard/DashboardHeader";
import NavigationPane from "@/components/dashboard/NavigationPane";
import DrillEditor from "@/components/dashboard/DrillEditor";
import SavedDrills from "@/components/dashboard/SavedDrills";
import ImagePreviewDialog from "@/components/dashboard/ImagePreviewDialog";
import SimulationDialog from "@/components/dashboard/SimulationDialog";
import VideoManagement from "@/components/dashboard/VideoManagement";
import { useState } from "react";

const Dashboard = () => {
  const {
    loading,
    drillText,
    setDrillText,
    generatedImage,
    setGeneratedImage,
    isGeneratingImage,
    savedDrills,
    showImageDialog,
    setShowImageDialog,
    handleLogout,
    handleCreateDrill,
    handleGenerateImage,
    handleDeleteDrill,
    navigate,
  } = useDashboard();

  const [selectedForConversion, setSelectedForConversion] = useState(false);
  const [showSimulationDialog, setShowSimulationDialog] = useState(false);
  const [selectedDrill, setSelectedDrill] = useState<any>(null);
  const [showVideoSection, setShowVideoSection] = useState(false);

  const handleSimulateDrill = () => {
    // Select the first drill for simulation if none is selected
    const drillToSimulate = selectedDrill || savedDrills[0];
    if (drillToSimulate) {
      setSelectedDrill(drillToSimulate);
      setShowSimulationDialog(true);
    }
  };

  // Create a wrapper function that uses the current drillText
  const handleGenerateImageClick = () => {
    if (drillText) {
      handleGenerateImage(drillText);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500/10 via-blue-600/5 to-blue-700/10">
      <div className="container mx-auto p-6">
        <div className="flex flex-col gap-6">
          <DashboardHeader 
            onLogout={handleLogout}
            onNavigateHome={() => navigate("/")}
          />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <NavigationPane
              onCreateDrill={handleCreateDrill}
              onGenerateImage={handleGenerateImageClick}
              onSimulateDrill={handleSimulateDrill}
              isGeneratingImage={isGeneratingImage}
              onNavigateToMarketplace={() => navigate("/marketplace")}
              selectedForConversion={selectedForConversion}
              onToggleVideoSection={() => setShowVideoSection(!showVideoSection)}
              showVideoSection={showVideoSection}
            />

            <div className="lg:col-span-9">
              {!showVideoSection ? (
                <>
                  <DrillEditor
                    drillText={drillText}
                    setDrillText={setDrillText}
                    generatedImage={generatedImage}
                    loading={loading}
                    onCreateDrill={handleCreateDrill}
                    selectedForConversion={selectedForConversion}
                    setSelectedForConversion={setSelectedForConversion}
                    setGeneratedImage={setGeneratedImage}
                  />

                  <SavedDrills
                    drills={savedDrills}
                    onDeleteDrill={handleDeleteDrill}
                    onSelectDrill={(drill) => {
                      setSelectedDrill(drill);
                      setShowSimulationDialog(true);
                    }}
                  />
                </>
              ) : (
                <VideoManagement />
              )}
            </div>
          </div>
        </div>
      </div>

      <ImagePreviewDialog
        showDialog={showImageDialog}
        setShowDialog={setShowImageDialog}
        generatedImage={generatedImage}
        onSaveDrill={handleCreateDrill}
      />

      <SimulationDialog
        showDialog={showSimulationDialog}
        setShowDialog={setShowSimulationDialog}
        selectedDrill={selectedDrill}
      />
    </div>
  );
};

export default Dashboard;
